import { useIntl } from "react-intl";
import { Segment, Table } from "semantic-ui-react";
import { IStatistics } from "../../models/statistics";

type Props = {
    title: string;
    statistics: IStatistics[];
    period: string;
};

export const StatisticsTable = ({ title, statistics, period }: Props) => {
    const intl = useIntl();

    const getTableRows = () => {
        const certificates = ["ucqBoatmaster", "government", "sport"];
        const qualifications = [
            "ucqHelmsman",
            "ucqAbleBoatman",
            "ucqBoatman",
            "ucqDeckhand",
            "ucqApprentice",
            "ucqMachineOperator",
        ];
        const specificAuthorizations = [
            "cityStretchBasel",
            "stretchWithRisksOberrhein",
            "stretchWithRisksMittellrhein",
            "radar",
            "maritimeWaterways",
            "largeConvoys",
        ];
        const securityPersonnel = ["adnBescheinigung", "ucqLngExpert", "ucqPassengerExpert"];

        const rows = [
            ...["certificates"],
            ...certificates,
            ...["qualifications"],
            ...qualifications,
            ...["specificAuthorizations"],
            ...specificAuthorizations,
            ...["securityPersonnel"],
            ...securityPersonnel,
        ];
        return rows;
    };

    const checkSubtitle = (row: string) => {
        return (
            row === "certificates" ||
            row === "qualifications" ||
            row === "specificAuthorizations" ||
            row === "securityPersonnel"
        );
    };

    return (
        <section>
            <div className="container-header">
                <h2>
                    {title}&nbsp;{period}
                </h2>
            </div>
            <Segment>
                <Table basic="very" compact="very">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell></Table.HeaderCell>
                            <Table.HeaderCell>
                                {intl.formatMessage({ id: "active" })}
                            </Table.HeaderCell>
                            {statistics.length > 1 && (
                                <>
                                    <Table.HeaderCell>
                                        {intl.formatMessage({ id: "issuedNew" })}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {intl.formatMessage({ id: "firstIssue" })}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {intl.formatMessage({ id: "expired" })}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {intl.formatMessage({ id: "suspended" })}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {intl.formatMessage({ id: "withdrawn" })}
                                    </Table.HeaderCell>
                                </>
                            )}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {getTableRows().map(row => (
                            <Table.Row key={row}>
                                <Table.Cell className={checkSubtitle(row) ? "subtitle" : ""}>
                                    {intl.formatMessage({ id: row })}
                                </Table.Cell>

                                <Table.Cell>{statistics[0][row]}</Table.Cell>
                                {statistics.length > 1 && (
                                    <>
                                        <Table.Cell>
                                            {
                                                Object.entries(statistics[1]).find(
                                                    el => el[0] === row
                                                )?.[1]
                                            }
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                Object.entries(statistics[2]).find(
                                                    el => el[0] === row
                                                )?.[1]
                                            }
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                Object.entries(statistics[3]).find(
                                                    el => el[0] === row
                                                )?.[1]
                                            }
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                Object.entries(statistics[4]).find(
                                                    el => el[0] === row
                                                )?.[1]
                                            }
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                Object.entries(statistics[5]).find(
                                                    el => el[0] === row
                                                )?.[1]
                                            }
                                        </Table.Cell>
                                    </>
                                )}
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </Segment>
        </section>
    );
};
